import React from 'react';
import { ConcreteRoles } from './roles';

export interface LandmarkProps {
  role: ConcreteRoles;
}

export type LandmarkExtendProps = Omit<LandmarkProps, 'role'>;

/**
 * Landmark is not actually a landmark, but is meant to provide structure and shared
 * functionality between all landmarks. Use one of the more precise landmarks or
 * create a new one.
 */
export const Landmark: React.FC<LandmarkProps> = props => {
  const { children, role } = props;
  return <div role={role}>{children}</div>;
};
